import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const ClearAlertsIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M15.98,17.89l-1.54-1.5H4.46c1.06-1.57,1.63-3.4,1.63-5.28v-1.31c0-2.25,1.92-4.08,4.28-4.08h.66c2.36,0,4.28,1.83,4.28,4.08v1.31c0,.7.09,1.39.25,2.06.1-.03.21-.04.32-.04h.06s0,0,0,0c.36,0,.7.15.96.4l1.4,1.36c-.66-1.15-1.02-2.45-1.02-3.78v-1.31c0-2.97-2.28-5.44-5.26-5.89v-.7c0-.69-.59-1.26-1.32-1.26s-1.32.56-1.32,1.26v.7c-2.98.45-5.26,2.92-5.26,5.89v1.31c0,1.78-.64,3.51-1.8,4.9l-.61.73c-.24.28-.28.67-.12,1s.51.53.89.53h13.13l.38-.39Z"
            fill="currentColor"
         />
         <path
            d="M15.03,20.9c-.08-.08-.13-.18-.13-.3,0-.12.04-.22.12-.3l2.37-2.44-2.43-2.36c-.08-.08-.13-.18-.13-.3,0-.12.04-.22.12-.3l.64-.66c.09-.09.19-.13.3-.13.12,0,.22.04.3.12l2.43,2.36,2.31-2.38c.08-.08.18-.13.3-.13.12,0,.22.04.3.12l.73.71c.09.09.14.19.13.3,0,.12-.04.22-.12.3l-2.31,2.38,2.43,2.36c.08.08.13.18.13.3.01.11-.03.21-.12.3l-.64.66c-.08.08-.18.13-.3.13-.12,0-.22-.04-.3-.12l-2.43-2.36-2.37,2.44c-.08.08-.18.13-.3.13-.11,0-.21-.03-.3-.12l-.73-.71Z"
            fill="currentColor"
         />
         <path
            d="M8.06,19.53c0,.67.28,1.31.77,1.78.49.47,1.16.73,1.86.73s1.37-.26,1.86-.73c.49-.47.77-1.11.77-1.78h-5.26Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default ClearAlertsIcon
